<template>
  <div>
    <el-table :data="orders" border style="width: 100%">
      <el-table-column prop="orderId" :label="$t('productSeckillOrder.orderId')" align="center"></el-table-column>
      <el-table-column :label="$t('productSeckillOrder.productImage')" align="center">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px; border-radius: 10px;"
            :src="scope.row.coverPhoto || '/img/noPhoto.jpg'" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="prodName" :label="$t('productSeckillOrder.productName')" align="center"></el-table-column>
      <el-table-column prop="buyerName" :label="$t('productSeckillOrder.buyer')" align="center"></el-table-column>
      <el-table-column prop="goodsNum" :label="$t('productSeckillOrder.quantity')" align="center"></el-table-column>
      <el-table-column prop="killPrice" :label="$t('productSeckillOrder.seckillPrice')"
        align="center"></el-table-column>
      <el-table-column prop="createTime" :label="$t('productSeckillOrder.purchaseTime')"
        align="center"></el-table-column>
      <el-table-column :label="$t('productSeckillOrder.status')" align="center">
        <template slot-scope="scope">
          {{ scope.row.state === 'C' ? $t('productSeckillOrder.completed') : $t('productSeckillOrder.pending') }}
        </template>
      </el-table-column>
      <el-table-column prop="endTime" :label="$t('productSeckillOrder.deadline')" align="center"></el-table-column>
    </el-table>

    <el-pagination @current-change="handlePageChange" :current-page="page" :page-size="10"
      layout="total, prev, pager, next, jumper" :total="total" style="margin-top: 20px;"></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'ProductSeckillOrderTable',
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handlePageChange(currentPage) {
      this.$emit('page-change', currentPage)
    }
  }
}
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}
</style>